<div class="dropdownEqualOperator">
	<p-autoComplete #inputElement
		[(ngModel)]="selectedOperator"
		[suggestions]="currentOperators" 
		(completeMethod)="completeMethod($event)"
		[dropdown]="true"
		(onSelect)="selectOperator()"
		[title]="tooltip"
		appendTo="body"
		[attr.aria-labelledby]="widget.label">
	</p-autoComplete>
	<div id="{{widget.label}}" class="visibilityOnlyForScreenreader">
		{{widget.label | hisUi}}
    </div>
</div>